module.exports = __webpack_public_path__ + "static/media/apa-logo.952bc03e.png";